<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>薪资标准</el-breadcrumb-item>
            <el-breadcrumb-item>薪档管理</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align:left">
        <el-col :span="24">
          <el-form
            :model="searchForm"
            :inline="true"
            class="demo-form-inline"
            size="small"
          >
            <el-form-item>
              <el-input
                filterable
                v-model="searchName" 
                clearable
                size="small"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" icon="el-icon-search" @click="quotaSearch"
                >搜索</el-button
              >
            </el-form-item>
            <el-form-item style="float:right">
              <el-button type="primary" size="small" @click="quotaAdd"
                >添加</el-button
              >
            </el-form-item>
          <el-form-item style="float:right">
           <el-button
                  size="small"
                  type="danger"
                  @click="batchDeleteSysitem()"
                  >删除</el-button
                >
          </el-form-item>

          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData"  ref="multipleTable" style="width: 100%">


          <el-table-column type="selection" width="55"></el-table-column>


            <el-table-column
              label="编号"
              :show-overflow-tooltip="true"
              min-width="25%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.Id }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="名称"
              :show-overflow-tooltip="true"
              min-width="25%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.ClassName }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="排序"
              :show-overflow-tooltip="true"
              min-width="25%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.Sort }}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" min-width="25%">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button>               
              </template>
            </el-table-column>
          </el-table>
          <el-row style="margin-top:10px">
            <el-col :span="24">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                style="float:right"
              ></el-pagination>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog title="添加信息" :visible.sync="dialogFormVisible">
      <el-form :model="dialogForm">
       
        <el-form-item label="名称">
          <el-input
            v-model="dialogForm.ClassName"
            autocomplete="off"
            style="width:90%"
          ></el-input>
        </el-form-item>
          <el-form-item label="排序号">
          <el-input
            v-model="dialogForm.Sort"
            autocomplete="off"
            style="width:90%"
          ></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelDialog">取 消</el-button>
        <el-button type="primary" @click="handleChangeDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic"; 
import {GetSalaryList,DeleteSysitem,GetSingleSysItem,GetSingleSysItemSort,AddSysItem} from '../../until/ZeusApiSDK/Logic/SalaryStanded';
export default { 
  data() {
    return { 
       searchName:'',//搜索信息
      currentUser:{},//当前用户 
      tableData: [],
      pageSizes: [10, 20, 30, 50,100],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      loading: true,
      visible:false,
      // 弹窗dialog
      dialogFormVisible: false,
      dialogForm: {
        Id: "",
        ClassName: "",//名称
        ParentId: "",//父类ID
        Sort: ""//排序      
      },
     
      searchForm: {
        extype: ""
      },
    };
  },
  created() {
     //获取当前用户信息
    this.getCurrentUser();
    this.GetSalaryList();

  },
  methods: {

     //获取当前用户
    getCurrentUser:function(){
        var userinfo = window.sessionStorage.getItem("userinfo");
        userinfo = JSON.parse(Decrypt(userinfo));
        this.currentUser = userinfo;
    },
    //获取薪资列表API
    GetSalaryList: async function() {
     this.loading = true;
      await GetSalaryList(
        4,
        this.pageIndex,
        this.pageSize,
        this.searchName  
      ).then(res => {
         this.loading = false;
        console.log( res.Data.DataList);
        this.tableData = res.Data.DataList;
        this.totalCount = res.Data.totalCount;
      });
    },

      //批量删除操作
    batchDeleteSysitem:function(){
      var userArray=this.$refs.multipleTable.selection;
      console.log(userArray);
      if(userArray<=0){
        this.$message({
          type: 'error',
          message: '请选择操作项'
        });
        return false;
      }
      this.loading=true;
      var ids='';
      userArray.forEach(item => {
        if(ids!="")
        {
           ids+=item.Id+',';
        }
        else
        {
           ids+=item.Id;
        }
       
      });
     
      //删除操作
      DeleteSysitem(this.currentUser.UserCode,ids).then(res=>{
        if(res.Code=="200"){
          this.$message({
          showClose: true,
          message: '删除成功',
          type: 'success'
        });
          this.GetSalaryList();
        }
       
        else if(res.Code=="500")
        {
            this.$message({
          showClose: true,
          message: "操作失败",
          type: 'error'
        });
         this.GetSalaryList();
        }
        else
        {
          this.$message({
          showClose: true,
          message:"未知",
          type: 'error'
        });
         this.GetSalaryList();
        }
      })

      
    },



    quotaSearch() {
      // 初始化page页面
      this.initPage();
      // 执行搜索api
      this.GetSalaryList();
    },
    quotaAdd() {

      GetSingleSysItemSort("3").then(res=>{
        
        if(res.Code=="200")
        {
           this.dialogForm = {                            
                     Sort: res.Msg//排序               
                          };   
          
        }    
      }),    
      // 打开弹窗
      this.openDialog();
    },

    handleEdit(index, row){     
        GetSingleSysItem(row.Id).then(res=>{
               if(res.Code=="200"){                         
               this.dialogForm = {       
                     Id: res.Data.Id,
                     ClassName: res.Data.ClassName,//名称
                     ParentId: res.Data.ParentId,//父类ID
                     Sort: res.Data.Sort//排序               
                          };         
                   }
                  
          }),      
      // 打开弹窗
      this.openDialog();
      // 点击取消 -> 弹窗清空   
},
    handleSizeChange(e) {
      this.initPage();
      this.pageSize = e;
      this.GetSalaryList();
    },
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.GetSalaryList();
    },
    handleCancelDialog() {
      // 关闭弹窗
      this.cancelDialog();
    },
    handleChangeDialog() {
     //编辑或新增保存
    
          if(this.dialogForm.Id==undefined)
          {
              this.dialogForm.Id="";
          }
      var data = {
          id:this.dialogForm.Id,
          ClassName:this.dialogForm.ClassName,
          Sort:this.dialogForm.Sort,
          userCode:this.currentUser.UserCode,
          ParentId:"4",
      };


        AddSysItem(data).then(res=>{
              if(res.Code=="200")
              {
               
                  this.$message({
                          showClose: true,
                          message: '操作成功',
                          type: 'success'
                     });
                      
              }
              else if(res.Code=="500")
              {
                  this.$message({
                          showClose: true,
                          message: '操作失败',
                          type: 'error'
                     });

                      
              }
              else{
                 this.$message({
                          showClose: true,
                          message: res.Message,
                          type: 'error'
                     });
              }
              console.log(res.Msg);
       // 关闭弹窗
      this.cancelDialog();
        })
   

    },
    openDialog() {
      // 打开弹窗
      this.dialogFormVisible = true;
    },
    cancelDialog() {
      this.dialogFormVisible = false;
      this.dialogForm = {
        Id: "",
        ClassName: "",//名称
        ParentId: "",//父类ID
        Sort: ""//排序
      };
    },
    initPage() {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.sub {
  font-size: 12px;
  color: #8f8d8d;
  text-align: left;
  /* margin-top: 10px; */
}
/deep/.contentP {
  margin-top: 5px;
  margin-bottom: 5px;
}
/deep/.mainArea {
  margin: 20px;
  height: 30%;
}
/deep/.bottomInput {
  display: inline;
}
/deep/.web__main-user img {
  margin-top: 18px;
}
</style>
